(function(){
'use strict';
const q=(s,r=document)=>r.querySelector(s);
const root=()=>window.Shopify?.routes?.root||'/';
let busy=false;

function showError(offer,message){
  const el=q('[data-offer-error]',offer||document);
  if(!el)return;
  el.textContent=message||'Something went wrong.';
  el.hidden=false;
}

function openMiniCart(){
  const mini=q('cart-notification');
  if(mini&&typeof mini.open==='function'){
    mini.open();
    return true;
  }
  const trigger=q('.minicart__action,.header__minicart .minicart-action,.header__minicart a');
  if(trigger){trigger.click();return true}
  return false;
}

async function addGift(btn){
  if(busy||btn.disabled)return;
  const offer=btn.closest('broek-2j-offer');
  const card=btn.closest('[data-gift-card]');
  const variantControl=q('[data-gift-variant]',card||document);
  const id=Number(variantControl?.value);
  if(!id){showError(offer,'Choose an available size first.');return}

  busy=true;
  const original=btn.textContent;
  btn.disabled=true;
  btn.textContent='ADDING…';
  const err=q('[data-offer-error]',offer||document);if(err)err.hidden=true;

  try{
    if(!window.BroekCartUX?.currentCart)throw new Error('Cart is still loading. Please try again.');
    let state=window.BroekCampaign?.getState?.();
    if(!state){const before=await window.BroekCartUX.currentCart();state=window.BroekCampaign?.state?.(before)}
    if(state&&state.remainingGifts<1)throw new Error('Add more eligible jeans to unlock another free top.');

    const response=await fetch(root()+'cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      credentials:'same-origin',
      body:JSON.stringify({items:[{id,quantity:1}]})
    });
    const payload=await response.json().catch(()=>({}));
    if(!response.ok)throw new Error(payload.description||payload.message||'This size could not be added.');

    if(!window.BroekCartUX?.refreshFromServer||!window.BroekCampaign?.refresh)throw new Error('Cart is still loading. Please try again.');
    const cart=await window.BroekCartUX.refreshFromServer();
    const finalState=await window.BroekCampaign.refresh(cart);
    if(!finalState)throw new Error('Could not verify the free-top discount. Please try again.');
    if(finalState.discountError||finalState.awaitingDiscount||finalState.freeTopQty<finalState.targetFree){
      showError(offer,finalState.discountError||'FREE-TOP DISCOUNT WAS NOT APPLIED. DO NOT CHECK OUT YET.');
      btn.disabled=true;
      btn.textContent='DISCOUNT NOT APPLIED';
      return;
    }
    btn.textContent='ADDED ✓';
    if(finalState.remainingGifts>0){
      setTimeout(()=>{if(btn.isConnected){btn.disabled=false;btn.textContent='ADD FREE TOP'}},650);
    }else{
      const drawer=q('[data-gift-drawer]',offer||document);
      if(drawer)drawer.hidden=true;
      document.body.classList.remove('broek-2j-open');
      openMiniCart();
    }
  }catch(error){
    showError(offer,error?.message||'Something went wrong.');
    btn.disabled=false;
    btn.textContent=original||'ADD FREE TOP';
  }finally{
    busy=false;
  }
}

function installGiftHandler(){
  const Offer=customElements.get('broek-2j-offer');
  if(!Offer)return false;
  Offer.prototype.addGift=function(event){
    event?.preventDefault?.();
    return addGift(event.currentTarget);
  };
  return true;
}
if(!installGiftHandler())customElements.whenDefined('broek-2j-offer').then(installGiftHandler);

document.addEventListener('broek:offer-state',()=>{
  if(busy)return;
  document.querySelectorAll('[data-add-gift]').forEach(btn=>{
    if(String(btn.textContent||'').trim()==='ADDED ✓')btn.textContent='ADD FREE TOP';
  });
});

})();
